export const generateCandidateFeedbackLink = (resultId: string) => {
  const baseUrl = "https://docs.google.com/forms/d/e/1FAIpQLSeVvSIpT1_mmz0V2SdahWboU64xTn-bM-AExuVNsGObo1jrUg/viewform?usp=pp_url";
  return `${baseUrl}&entry.2068949615=${resultId}`;
};
